module.exports = __webpack_public_path__ + "static/media/Levin Fabric Ottoman_Dark Grey.695943d7.png";